import { render, staticRenderFns } from "./downloads.vue?vue&type=template&id=1fe15c06&scoped=true&"
import script from "./downloads.vue?vue&type=script&lang=js&"
export * from "./downloads.vue?vue&type=script&lang=js&"
import style0 from "./downloads.vue?vue&type=style&index=0&id=1fe15c06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe15c06",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Card: require('/opt/build/repo/components/basics/Card.vue').default,TheSpinner: require('/opt/build/repo/components/basics/TheSpinner.vue').default,AppFaqs: require('/opt/build/repo/components/AppFaqs.vue').default,CallToAction: require('/opt/build/repo/components/elements/CallToAction.vue').default})
